import axios from 'axios';

// fly.io 上的机器闲置就会休眠，下一次请求要等它冷启动（实测约 7 秒）。
// 这段时间 axios 只是挂着，页面上没有任何反馈，按钮看起来像坏了——用户只能刷新。
// 这里做两件事：慢了就明确显示「正在唤醒」，网络层失败自动重试，不必手动刷新。
//
// 与 Mnemos 的 web/src/api.ts 是同一套思路，两边各自实现（一个 axios、一个 fetch）。

const SLOW_AFTER_MS = 1200;
const RETRIES = 2;

let inFlight = 0;
let banner = null;

function show() {
  if (banner) return;
  banner = document.createElement('div');
  banner.className = 'wake-banner';
  banner.setAttribute('role', 'status');
  banner.innerHTML = '<span class="wake-dot"></span>服务器唤醒中…';
  document.body.appendChild(banner);
}

function hide() {
  if (!banner) return;
  banner.remove();
  banner = null;
}

export function installWakeHandling() {
  axios.interceptors.request.use((config) => {
    inFlight++;
    config.__slowTimer = setTimeout(show, SLOW_AFTER_MS);
    return config;
  });

  const done = (config) => {
    if (config?.__slowTimer) clearTimeout(config.__slowTimer);
    if (--inFlight <= 0) { inFlight = 0; hide(); }
  };

  axios.interceptors.response.use(
    (res) => { done(res.config); return res; },
    async (err) => {
      const cfg = err.config;
      done(cfg);
      // 只重试网络层失败（机器正在起来），HTTP 错误码原样抛给调用方
      if (!cfg || err.response) return Promise.reject(err);
      cfg.__retry = (cfg.__retry || 0) + 1;
      if (cfg.__retry > RETRIES) return Promise.reject(err);
      await new Promise((r) => setTimeout(r, 800 * cfg.__retry));
      return axios(cfg);
    },
  );
}
